import { Component, Input } from '@angular/core';
import { TextSizes, TextType } from '../../../enums';
import { TextComponent } from '../../text/text.component';
@Component({
  selector: 'app-information-label',
  templateUrl: './information-label.component.html',
  styleUrls: ['./information-label.component.scss'],
  imports: [TextComponent],
})
export class InformationLabelComponent {
  @Input() text: string | undefined;

  readonly TextType = TextType;

  readonly TextSize = TextSizes;
}
